// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3y5Di","consentsList":"PatientConsents_consentsList__3BXVY","consentsListEmpty":"PatientConsents_consentsListEmpty__3ZjeY"};